import { render, staticRenderFns } from "./m_prize.vue?vue&type=template&id=3103f8a2&scoped=true&"
import script from "./m_prize.vue?vue&type=script&lang=js&"
export * from "./m_prize.vue?vue&type=script&lang=js&"
import style0 from "./m_prize.vue?vue&type=style&index=0&id=3103f8a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3103f8a2",
  null
  
)

export default component.exports